"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = void 0;
var react_1 = __importDefault(require("react"));
var notificationService_1 = require("../contexts/notificationService");
exports.useNotification = function () { return react_1.default.useContext(notificationService_1.NotificationServiceContext); };
